import React, {useEffect, useState, createContext, useContext} from 'react';

export const MediaQueryContext = createContext<{width: number; height: number} | undefined>(
  undefined,
);

type MediaQueryProvider = {};

export const MediaQueryProvider: React.FC<MediaQueryProvider> = ({children}) => {
  const [{height, width}, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    window.addEventListener('resize', () =>
      setDimensions({width: window.innerWidth, height: window.innerHeight}),
    );
  }, []);

  return (
    <MediaQueryContext.Provider value={{width, height}}>{children}</MediaQueryContext.Provider>
  );
};

export const useMediaQueryContext = () => {
  const context = useContext(MediaQueryContext);

  if (!context) {
    throw Error(`Context '${MediaQueryContext}' not found`);
  }

  return context;
};

export default MediaQueryProvider;
